import {
  faArrowRightFromBracket,
  faAward,
  faChevronDown,
  faChevronUp,
  faClock,
  faFolder,
  faUser,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";

/** Sidebar navigation icons — pro-regular for consistent weight at 18px. */
export const sidebarIcons = {
  myCertificates: faAward,
  admin: faFolder,
  sectionToggle: faChevronUp,
  headerCourseMenu: faChevronDown,
  expiredCourse: faClock,
  logout: faArrowRightFromBracket,
  closeDrawer: faXmark,
  user: faUser,
} as const;
